import React from "react";

function NotFoundPage() {
  return (
    <h1 style={{textAlign: "center", color: "wheat", fontSize: "3rem"}}>
      Not Found
    </h1>
  );
}

export default NotFoundPage;
